import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import { api, formatDate } from "../lib/api";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Comentarios from "../components/Comentarios";
import ReadingProgress from "../components/ReadingProgress";
import NewsletterBlock from "../components/NewsletterBlock";
import useReveal from "../hooks/useReveal";

export default function Entrada() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [relacionadas, setRelacionadas] = useState([]);
  const [notFound, setNotFound] = useState(false);

  useReveal();

  useEffect(() => {
    window.scrollTo({ top: 0 });
    setPost(null);
    setNotFound(false);
    api
      .get(`/posts/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
    api
      .get("/posts/populares", { params: { limit: 4 } })
      .then((r) => setRelacionadas((r.data || []).filter((p) => p.slug !== slug).slice(0, 3)));
  }, [slug]);

  if (notFound) {
    return (
      <>
        <Nav />
        <div className="container" style={{ padding: 120, textAlign: "center" }}>
          <h1>Esta entrada no existe.</h1>
          <p style={{ color: "var(--ink-2)", marginTop: 16 }}>
            Puede que la haya movido o archivado.
          </p>
          <Link to="/escritos" className="btn btn-primary" style={{ marginTop: 24 }}>
            Volver al archivo →
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  if (!post) {
    return (
      <>
        <Nav />
        <div className="container" style={{ padding: 120, textAlign: "center", color: "var(--ink-3)" }}>
          Cargando…
        </div>
      </>
    );
  }

  return (
    <>
      <ReadingProgress />
      <Nav />

      <article className="container" data-testid="article-page">
        <div className="article-wrap">
          <div className="article-meta reveal">
            <span className="tag">{post.categoria}</span>
            <span>{formatDate(post.fecha_publicacion)}</span>
            <span>· {post.tiempo_lectura} min de lectura</span>
            <span>· {(post.vistas || 0).toLocaleString("es-ES")} lecturas</span>
          </div>
          <h1 className="article-title reveal d1" data-testid="article-title">
            {post.titulo}
          </h1>
          <p className="article-excerpt reveal d2">{post.excerpt}</p>
          <div className="article-cover reveal d3">
            <img src={post.imagen_url} alt={post.titulo} />
          </div>
          <div className="article-content" data-testid="article-content">
            <ReactMarkdown>{post.contenido_md}</ReactMarkdown>
          </div>

          <div className="article-divider" />

          <div style={{ marginBottom: 56 }}>
            <div className="section-eyebrow" style={{ marginBottom: 12 }}>
              Conversación
            </div>
            <h2 className="section-title" style={{ marginBottom: 32 }}>
              Lo que dicen <em>otros lectores</em>.
            </h2>
            <Comentarios slug={post.slug} />
          </div>
        </div>
      </article>

      {relacionadas.length > 0 && (
        <section className="section" data-testid="related-section">
          <div className="container">
            <div className="section-head">
              <div>
                <div className="section-eyebrow">Entradas relacionadas</div>
                <h2 className="section-title">
                  Puede que también <em>te llegue</em>.
                </h2>
              </div>
              <Link to="/escritos" className="section-link">
                Ver archivo →
              </Link>
            </div>
            <div className="posts-grid">
              {relacionadas.map((p, i) => (
                <Link
                  key={p.slug}
                  to={`/entrada/${p.slug}`}
                  className={`post-card reveal d${i + 1}`}
                  data-testid={`related-${p.slug}`}
                >
                  <div className="post-img">
                    <img src={p.imagen_url} alt={p.titulo} />
                    <div className="post-img-top">
                      <span className="tag tag-accent">{p.categoria}</span>
                    </div>
                  </div>
                  <h3 className="post-title">{p.titulo}</h3>
                  <p className="post-excerpt">{p.excerpt}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      <NewsletterBlock />
      <Footer />
    </>
  );
}
